import React, { useState } from "react";
import { Button, FormControlLabel, Checkbox } from "@mui/material";
import { PMDialog } from "../../../utils/PMDialog";
import { useTranslation } from "react-i18next";

export const BillingAttachmentDialog = ({
  open,
  onClose,
  onExport,
}) => {
  const { t } = useTranslation();
  const [settings, setSettings] = useState({
    show_line_details: true,
    show_unit_price: false,
    show_completed_quantity: true,
    show_progress_percentage: true,
    show_group_totals: true,
    show_only_groups: false,
    show_invoices: true,
    show_total_contract: true,
    show_only_completed_total: false,
  });

  const handleExport = () => {
    onExport(settings);
  };

  return (
    <PMDialog
      open={open}
      onClose={onClose}
      title="Eksporter faktureringsvedlegg"
      size="lg"
      closeOnOutsideClick={false}
    >
      <div className="space-y-4">
        <p className="text-sm text-gray-600 mb-4">
          Velg hvilken informasjon som skal inkluderes i faktureringsvedlegg. 
          Dette dokumentet inneholder faktureringsplan, kontraktlinjer og fakturaer.
        </p>

        <div className="border-t pt-4">
          <h3 className="text-sm font-medium text-gray-700 mb-3">Kontraktlinjer</h3>
          
          {/* Show only groups */}
          <FormControlLabel
            control={
              <Checkbox
                checked={settings.show_only_groups}
                onChange={(e) => setSettings({ ...settings, show_only_groups: e.target.checked })}
              />
            }
            label="Vis kun grupper (skjul linjer)"
          />

          {!settings.show_only_groups && (
            <>
              {/* Show line details */}
              <FormControlLabel
                control={
                  <Checkbox
                    checked={settings.show_line_details}
                    onChange={(e) => setSettings({ ...settings, show_line_details: e.target.checked })}
                  />
                }
                label="Vis linjedetaljer"
              />

              {/* Show unit price */}
              <FormControlLabel
                control={
                  <Checkbox
                    checked={settings.show_unit_price}
                    onChange={(e) => setSettings({ ...settings, show_unit_price: e.target.checked })}
                  />
                }
                label="Vis enhetspris"
              />

              {/* Show completed quantity */}
              <FormControlLabel
                control={
                  <Checkbox
                    checked={settings.show_completed_quantity}
                    onChange={(e) => setSettings({ ...settings, show_completed_quantity: e.target.checked })}
                  />
                }
                label="Vis utført mengde"
              />

              {/* Show progress percentage */}
              <FormControlLabel
                control={
                  <Checkbox
                    checked={settings.show_progress_percentage}
                    onChange={(e) => setSettings({ ...settings, show_progress_percentage: e.target.checked })}
                  />
                }
                label="Vis fremdriftsprosent"
              />

              {/* Show total contract */}
              <FormControlLabel
                control={
                  <Checkbox
                    checked={settings.show_total_contract}
                    onChange={(e) => setSettings({ ...settings, show_total_contract: e.target.checked })}
                  />
                }
                label="Vis total kontrakt pr. linje"
              />
            </>
          )}

          {/* Show group totals */}
          <FormControlLabel
            control={
              <Checkbox
                checked={settings.show_group_totals}
                onChange={(e) => setSettings({ ...settings, show_group_totals: e.target.checked })}
              />
            }
            label="Vis totalsum per gruppe"
          />

          {/* Show only completed total */}
          <FormControlLabel
            control={
              <Checkbox
                checked={settings.show_only_completed_total}
                onChange={(e) => setSettings({ ...settings, show_only_completed_total: e.target.checked })}
              />
            }
            label="Vis kun total utført pr. gruppe"
          />
        </div>

        <div className="border-t pt-4">
          <h3 className="text-sm font-medium text-gray-700 mb-3">Fakturaer</h3>
          
          {/* Show invoices */}
          <FormControlLabel
            control={
              <Checkbox
                checked={settings.show_invoices}
                onChange={(e) => setSettings({ ...settings, show_invoices: e.target.checked })}
              />
            }
            label="Vis fakturaer (A-konto og sluttfaktura)"
          />
        </div>

        {/* Actions */}
        <div className="flex justify-end space-x-3 mt-6 pt-4 border-t">
          <Button onClick={onClose}>
            {t("common.cancel")}
          </Button>
          <Button
            onClick={handleExport}
            variant="contained"
            className="bg-blue-600 hover:bg-blue-700"
          >
            Eksporter PDF
          </Button>
        </div>
      </div>
    </PMDialog>
  );
};

